import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import { glass, radii } from '../../theme/designTokens';

const GlassCard = ({
  children,
  variant = 'light',
  hover = true,
  sx = {},
  ...motionProps
}) => {
  const styles = variant === 'dark' ? glass.dark : glass.light;

  return (
    <Box
      component={motion.div}
      whileHover={hover ? { y: -6, boxShadow: '0 16px 48px rgba(15,23,42,0.14)' } : undefined}
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
      sx={{
        ...styles,
        borderRadius: radii.lg,
        transition: 'box-shadow 0.3s ease, transform 0.3s ease',
        ...sx,
      }}
      {...motionProps}
    >
      {children}
    </Box>
  );
};

export default GlassCard;
